import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import useAppStore from "../../store/useAppStore";
import useLayoutStore from "../../store/useLayoutStore";

import SearchBar from "../elements/SearchBar";

const ViewDevicesHeader = () => {
    const devicesVisibility = useAppStore((state) => state.devicesVisibility)
    const setDevicesVisibility = useAppStore(state => state.setDevicesVisibility)

    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)
    const activeThemeClass = isDarkTheme ? 'dark-color' : 'white-color'

    const handleVisibilityChange = (e) => {
        const target = e.target.closest('[data-name]');
        if (!target) return;
        const name = target.getAttribute('data-name');
        setDevicesVisibility(name)
    }

    return (
        <div className="view-header-container">
            <div className="view-header-top">
                <div className={`v-header-name ${activeThemeClass}`}>Uređaji</div>
                <div className={`v-header-description ${isDarkTheme ? "dark-color" : ""}`}>Prikazuju se uređaji kojima aplikacija upravlja, kao i njihov status (ON-uređaj je uključen, OFF-uređaj je isključen). Kada zaposleni iz jedne grupe napuste radno mesto, aplikacija isključuje sva svetla i utičnice koje pripadaju toj grupi. Svetla i utičnice koje nisu grupisane će biti isključene kada poslednji zaposleni napusti radno mesto. Kada sistem prepozna da se bar jedan zaposleni evidentirao, uključiće sve pametne utičnice iz njegove grupe i utičnice koje nisu grupisane, dok će svetlo korisnici uključivati prema potrebi. Senzori pojedinačno šalju informacije o statusu na desetak sekundi.</div>
                <div className="v-header-tools-container devices-tools-container">
                    <div className="v-header-buttons-div" onClick={handleVisibilityChange}>
                        <DeviceHeaderButton
                            name="allDevices"
                            icon="./views/Grupa.svg"
                            tooltip="Svi uređaji"
                            active={devicesVisibility === "allDevices"}
                        />
                        <DeviceHeaderButton
                            name="statusOn"
                            icon="./views/TipoviUredjaja.svg"
                            tooltip="Status ON"
                            active={devicesVisibility === "statusOn"}
                        />
                        <DeviceHeaderButton
                            name="statusOff"
                            icon="./views/Prostorija.svg"
                            tooltip="Status OFF"
                            active={devicesVisibility === "statusOff"}
                        />
                    </div>
                    <SearchBar />
                </div>
            </div>
        </div>
    )
}

const DeviceHeaderButton = ({ name, active, icon, tooltip }) => {
    const isTouchDevice = useLayoutStore(state => state.isTouchDevice)
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)

    const activeClass = isDarkTheme ? 'dark-active' : 'active'

    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className="v-header-button-div">
            <button
                className={`v-header-icon-button ${active ? activeClass : ""}`}
                data-name={name}
                onMouseEnter={() => !isTouchDevice && setIsHovered(true)}
                onMouseLeave={() => !isTouchDevice && setIsHovered(false)}
            >
                <img src={icon} alt={name} className={`${isDarkTheme ? 'dark-filter' : ''}`} />
            </button>
            <AnimatePresence>
                {isHovered && (
                    <motion.div
                        className={`v-header-button-tooltip  ${isDarkTheme ? 'tooltip-dark' : 'tooltip-white'}`}
                        initial={{ opacity: 0, y: -14 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -14 }}
                        transition={{ duration: 0.19, ease: "easeOut" }}
                    >
                        {tooltip}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default ViewDevicesHeader;